export default (rawPath, pathParams = {}, queryParams = {}) => {
  let path = rawPath;
  Object.keys(pathParams).forEach(key => {
    path = path.replace(`:${key}`, encodeURIComponent(pathParams[key]));
  });
  Object.keys(queryParams)
    .filter(key => queryParams[key] !== null && typeof queryParams[key] !== 'undefined')
    .forEach((key, index) => {
      const param = encodeURIComponent(queryParams[key]);

      if (index === 0) {
        path += `?${key}=${param}`;
      } else {
        path += `&${key}=${param}`;
      }
    });
  return path;
};
